import constants from "../constants/index.json";

export const buildUrl = (relativeUrl: string) => {
  try {

    if (relativeUrl.slice(0, 1) === "/") {
      // override the base url if necessary
      if (constants.baseUrl.length > 0) {
        return `${constants.baseUrl}${relativeUrl}`;
      }

      return (
        window.location.protocol +
        "//" +
        window.location.host +
        relativeUrl
      );
    } else {
      const newUrl = new URL(relativeUrl, window.location.href);
      return newUrl.href;
    }
  } catch {
    console.error("Unable to parse the URL passed in " + relativeUrl);
    return "";
  }
};
